import React from 'react';

const NotificationToaster = ({ notifications }) => (
  <div className="fixed top-4 right-4 z-50 space-y-2 max-w-sm">
    {notifications.map((notification) => (
      <div
        key={notification.id}
        className={`p-4 rounded-lg shadow-lg border-l-4 ${
          notification.type === "success"
            ? "bg-green-50 border-green-400 text-green-700"
            : notification.type === "error"
            ? "bg-red-50 border-red-400 text-red-700"
            : "bg-blue-50 border-blue-400 text-blue-700"
        }`}
      >
        <div className="flex items-start">
          {notification.type === "success" && (
            <svg className="w-5 h-5 mr-3 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
            </svg>
          )}
          {notification.type === "error" && (
            <svg className="w-5 h-5 mr-3 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
            </svg>
          )}
          {notification.type === "info" && (
            <svg className="w-5 h-5 mr-3 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
            </svg>
          )}
          <div className="flex-1">
            <p className="text-sm font-medium">{notification.message}</p>
          </div>
        </div>
      </div>
    ))}
  </div>
);

export default NotificationToaster;